import React, { useState } from 'react';
import { FaUserTie, FaBuilding } from 'react-icons/fa';
import './HomePage.css';
import Header from '../components/Header';

export default function HomePage() {
  const [locale, setLocale] = useState(localStorage.getItem('locale') || 'kz');

  const t = {
    kz: {
      welcome: 'EXPERTISE',
      description:
        'Мемлекеттік платформа – мектепке дейінгі ұйымдар мен орта білім беру ұйымдарына арналған оқулықтар мен оқу-әдістемелік кешендерді (ОӘК) сараптау процесін автоматтандыру, сондай-ақ осы процесс бойынша талдау мен есептілікті жүргізуге арналған.',
      loginEmployee: 'BMSO қызметкерлері үшін',
      loginPublisher: 'Баспалар үшін',
      buttons: 'Түймелер',
    },
    ru: {
      welcome: 'EXPERTISE',
      description:
        'Государственная платформа для автоматизации процессов экспертизы учебников и учебно-методических комплексов (УМК) для организаций дошкольного и среднего образования, а также ведения аналитики и отчетности по данному процессу.',
      loginEmployee: 'Для сотрудников BMSO',
      loginPublisher: 'Вход издательств',
      buttons: 'Кнопки',
    },
  }[locale];

  return (
    <div className="homepage">
      {/* правый вертикальный орнамент */}
<div className="ornament glow sparkles" aria-hidden="true">
  <div className="orn-img a" style={{ backgroundImage: 'url(/img/ornament.svg)' }} />
  <div className="orn-img b" style={{ backgroundImage: 'url(/img/ornament.svg)' }} />
  <div className="orn-img c" style={{ backgroundImage: 'url(/img/ornament.svg)' }} />
</div>




      {/* верхняя полоса с хедером */}
      <div className="container header-wrap">
        <Header locale={locale} setLocale={setLocale} />
      </div>

      {/* основной герой-блок */}
      <section className="container hero">
        <div className="hero-left">
          <div className="wordmark-wrap">
            <h1 className="wordmark">{t.welcome}</h1>
          </div>

          <p className="subtext">{t.description}</p>

          <div className="cta-row">
            <a href="/login" className="entry-button">
              <FaUserTie className="icon" /> {t.loginEmployee}
            </a>
            <a href="/publisher/login" className="entry-button">
              <FaBuilding className="icon" /> {t.loginPublisher}
            </a>
          </div>
        </div>
      </section>
    
    </div>
  );
}
